/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const KindType = {
    DEFAULT: 'DEFAULT',
    OPTIONAL: 'OPTIONAL',
    REGULAR: 'REGULAR'
} as const;
export type KindType = typeof KindType[keyof typeof KindType];

